import { type CSSProperties } from 'react'
import { css } from '@emotion/react'

import { RADIUS_1 } from '@Styles/constants/radius'

export const paper: CSSProperties = {
  borderTopLeftRadius: RADIUS_1,
  borderTopRightRadius: RADIUS_1,
}

export const wrapper = css({
  display: 'flex',
  flexDirection: 'column',
})
